"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverWrapper = exports.PopoverContainer = exports.StyledButton = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var Button_1 = __importDefault(require("../Button"));
var Popover_1 = __importDefault(require("@mui/material/Popover"));
exports.StyledButton = (0, styled_1.default)(Button_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  width: 228px;\n  height: 40px;\n  padding: 12px 16px;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: inline-flex;\n  width: 228px;\n  height: 40px;\n  padding: 12px 16px;\n  justify-content: center;\n  align-items: center;\n"])));
exports.PopoverContainer = (0, styled_1.default)(Popover_1.default)({
    pointerEvents: 'none',
    '.MuiPopover-paper': {
        pointerEvents: 'auto',
        padding: '16px 24px',
    },
});
exports.PopoverWrapper = (0, styled_1.default)('div')({
    width: 'fit-content',
});
var templateObject_1;
//# sourceMappingURL=styles.js.map